var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-header" }, [
        _c(
          "div",
          [
            _c(
              "el-radio-group",
              {
                staticStyle: { "margin-bottom": "20px" },
                on: { change: _vm.handleTabChange },
                model: {
                  value: _vm.tabPosition,
                  callback: function($$v) {
                    _vm.tabPosition = $$v
                  },
                  expression: "tabPosition"
                }
              },
              [
                _c("el-radio-button", { attrs: { label: "有效" } }, [
                  _vm._v("有效")
                ]),
                _c("el-radio-button", { attrs: { label: "失效" } }, [
                  _vm._v("失效")
                ])
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !_vm.canEdit
                },
                on: { click: _vm.handleAdd }
              },
              [_vm._v("添加")]
            )
          ],
          1
        )
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": _vm.headerStyle,
            "row-class-name": _vm.tableRowClassName
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              align: "center",
              width: "80",
              type: "index"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "姓名",
              align: "center",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.name || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "idCard",
              label: "身份证",
              align: "center",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.idCard || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "phone",
              label: "电话",
              align: "center",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.phone || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "company", label: "所属单位", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.company || "-"))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "area", label: "合作区域/园区", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.areas && scope.row.areas.length
                      ? _c(
                          "div",
                          { staticClass: "tag-container" },
                          _vm._l(scope.row.areas, function(area, index) {
                            return _c(
                              "el-tag",
                              {
                                key: index,
                                staticClass: "skill-tag",
                                attrs: { size: "small", type: "success" }
                              },
                              [_vm._v(_vm._s(area))]
                            )
                          }),
                          1
                        )
                      : _c("div", [_vm._v("-")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "category", label: "人员类别", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticStyle: { color: "#219aff" } }, [
                      _vm._v(_vm._s(scope.row.category || "-"))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "skills", label: "技能标签", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.skills && scope.row.skills.length
                      ? _c(
                          "div",
                          { staticClass: "tag-container" },
                          _vm._l(scope.row.skills, function(skill, index) {
                            return _c(
                              "el-tag",
                              {
                                key: index,
                                staticClass: "skill-tag",
                                attrs: { size: "small", type: "success" }
                              },
                              [_vm._v(_vm._s(skill))]
                            )
                          }),
                          1
                        )
                      : _c("div", [_vm._v("-")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              align: "center",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.status || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      {
                        on: {
                          command: function(command) {
                            return _vm.handleCommand(command, scope.row)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "el-dropdown-link" }, [
                          _vm._v("\n            更多操作 "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "edit",
                                  disabled: !_vm.canEdit
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "delete",
                                  disabled:
                                    !_vm.isAuthorizedUser() ||
                                    scope.row.status !== "失效" ||
                                    !_vm.canEdit
                                }
                              },
                              [_vm._v("删除")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "history" } },
                              [_vm._v("历史记录")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageParams.skip,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageParams.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.isEdit ? "编辑合作资源人员" : "添加合作资源人员",
            visible: _vm.dialogVisible,
            direction: "rtl",
            size: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "employeeForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入姓名" },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证", prop: "idCard" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入身份证号码" },
                        model: {
                          value: _vm.form.idCard,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "idCard", $$v)
                          },
                          expression: "form.idCard"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "电话", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号码" },
                        model: {
                          value: _vm.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属单位", prop: "partnerId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择所属单位" },
                          on: { change: _vm.handlePartnerChange },
                          model: {
                            value: _vm.form.partnerId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "partnerId", $$v)
                            },
                            expression: "form.partnerId"
                          }
                        },
                        _vm._l(_vm.partnerList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "合作区域/园区", prop: "areas" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            placeholder: "请选择合作区域/园区"
                          },
                          on: { focus: _vm.handleSelectFocus },
                          model: {
                            value: _vm.form.areas,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "areas", $$v)
                            },
                            expression: "form.areas"
                          }
                        },
                        _vm._l(_vm.campusOptions, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: Object.values(item)[0],
                              value: Object.values(item)[0]
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "人员类别", prop: "category" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择人员类别" },
                          model: {
                            value: _vm.form.category,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "category", $$v)
                            },
                            expression: "form.category"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "计费HC", value: "计费HC" }
                          }),
                          _c("el-option", {
                            attrs: { label: "专职专项", value: "专职专项" }
                          }),
                          _c("el-option", {
                            attrs: { label: "合作专项", value: "合作专项" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "技能标签", prop: "skills" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            placeholder: "请选择技能标签"
                          },
                          model: {
                            value: _vm.form.skills,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "skills", $$v)
                            },
                            expression: "form.skills"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "网络复检", value: "网络复检" }
                          }),
                          _c("el-option", {
                            attrs: { label: "服务器专项", value: "服务器专项" }
                          }),
                          _c("el-option", {
                            attrs: { label: "资源交付", value: "资源交付" }
                          }),
                          _c("el-option", {
                            attrs: { label: "特殊变更", value: "特殊变更" }
                          }),
                          _c("el-option", {
                            attrs: { label: "裁撤相关", value: "裁撤相关" }
                          }),
                          _c("el-option", {
                            attrs: { label: "改造", value: "改造" }
                          }),
                          _c("el-option", {
                            attrs: { label: "资产", value: "资产" }
                          }),
                          _c("el-option", {
                            attrs: { label: "机架裁撤", value: "机架裁撤" }
                          }),
                          _c("el-option", {
                            attrs: { label: "ODF裁撤", value: "ODF裁撤" }
                          }),
                          _c("el-option", {
                            attrs: { label: "专线裁撤", value: "专线裁撤" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择状态" },
                          model: {
                            value: _vm.form.status,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "有效", value: "有效" }
                          }),
                          _c("el-option", {
                            attrs: { label: "失效", value: "失效" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submitForm }
                        },
                        [_vm._v("确定")]
                      ),
                      _c("el-button", { on: { click: _vm.handleClose } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("history-dialog", {
        attrs: {
          visible: _vm.historyDialogVisible,
          partnerId: _vm.currentEmployeeId
        },
        on: {
          "update:visible": function($event) {
            _vm.historyDialogVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }